// CSV parsing + platform detection for order imports.
// Uses PapaParse so quoted multi-line fields (e.g. Etsy personalisation that
// spans several lines) parse correctly — the legacy Utilities.parseCsv equivalent.

import Papa from 'papaparse';
import { SOURCE } from '../constants';

/** Parse CSV text to an array of string rows (array-of-arrays). Strips BOM. */
export function parseCsvText(text) {
  const { data } = Papa.parse(text, { skipEmptyLines: false });
  if (data.length && data[0].length && typeof data[0][0] === 'string') {
    data[0][0] = data[0][0].replace(/^﻿/, '');
  }
  return data;
}

const includesCell = (row, needle) =>
  Array.isArray(row) && row.some((c) => String(c).trim().toLowerCase() === needle);

/**
 * Detect the platform from filename first (matches the legacy dispatch), then
 * fall back to header signatures. Returns a SOURCE value or null.
 */
export function sniffPlatform(filename, rows) {
  const name = (filename || '').toLowerCase();
  if (name.includes('shopify')) return SOURCE.SHOPIFY;
  if (name.includes('ebay')) return SOURCE.EBAY;
  if (name.includes('etsy') && name.includes('items')) return SOURCE.ETSY;

  // Header-signature fallback (scan the first few rows — eBay has junk rows first).
  const head = (rows || []).slice(0, 5);
  for (const row of head) {
    if (includesCell(row, 'sales record number') && includesCell(row, 'order number')) {
      return SOURCE.EBAY;
    }
  }
  const header = (rows && rows[0]) || [];
  const lc = header.map((h) => String(h).trim().toLowerCase());
  if (lc.includes('lineitem name') && lc.includes('financial status')) return SOURCE.SHOPIFY;
  if (lc.includes('order id') && lc.includes('sale date') && lc.includes('variations')) {
    return SOURCE.ETSY;
  }
  return null;
}

/** Build a {headerName: index} map from a header row. */
export function headerIndex(headerRow) {
  const map = {};
  headerRow.forEach((h, i) => {
    map[String(h).trim()] = i;
  });
  return map;
}
